import {comparators} from "../../consts/meta";

export function initExclusionList() {
    // Process every attribute and build an exclusion list
    for (const key in this._attributeMap) {
        processExclusionListForAttr.call(this, key)
    }

    return this._exclusionList
}

export function updateExclusionList(attrName) {
    // Process every relevant attribute and modify the exclusion list
    const depMap = this.meta().exclusionDependencies();
    const relevantAttrs = depMap[attrName] || [];

    for (const attr of relevantAttrs) {
        processExclusionListForAttr.call(this, attr)
    }

    return this._exclusionList
}

function processExclusionListForAttr(attrName) {
    if (isAttributeIncluded.call(this, attrName)) {
        delete this._exclusionList[attrName]
    } else {
        this._exclusionList[attrName] = true
    }

    updateExclusionList.call(this, attrName)
}

function useComparator(criteria, value) {
    switch (criteria.comparator) {
        case comparators.eq:
            return criteria.value === value
        case comparators.doesNotExist:
            if (!value) {
                return true
            }
            return false
        case comparators.existsNeq:
            if (!value) {
                return false
            }
            return criteria.value !== value
        case comparators.includes:
            return value.includes(criteria.value)
        default:
            throw new Error(`unhandled comparator ${criteria.comparator}`)
    }
}

// Note: Exported for testing purposes only.
export const useComparator_Test = useComparator;

export function isAttributeIncluded(attrName, resolvedList = {}, seenList = {}) {
    const excludedUnlessCriterias = this.metaField(attrName).attr('excludedUnlessConfigs');
    if (!excludedUnlessCriterias) return true

    seenList[attrName] = true;
    // debugger;
    for (let config of excludedUnlessCriterias) {
        for (let exclusionCriteria of config) {
            const shouldBeIncluded = checkIfShouldBeIncluded(this, exclusionCriteria, seenList, resolvedList, attrName);
            if (!shouldBeIncluded) {
                return false
            }
        }
    }

    // All checks have passed
    return true
}

const checkIfShouldBeIncluded = (thisParam, exclusionCriteria, seenList, resolvedList, attrName) => {
    const {jsonName: dependencyAttrName, criteria} = exclusionCriteria;
    const dependencyAttributeValue = thisParam.attr(dependencyAttrName);

    // Only resolve dependencies that we haven't encountered yet
    if (!resolvedList[dependencyAttrName]) {
        // Detect circular dependencies
        if (seenList[dependencyAttrName]) {
            throw new Error(`cycle detected by attrName: ${attrName} on dependencyAttrName: ${dependencyAttrName}`)
        }
        // Check dependency criteria
        if (!isAttributeIncluded.call(thisParam, dependencyAttrName, resolvedList, seenList)) {
            return false
        }
    }

    resolvedList[dependencyAttrName] = true

    let oneMatches = false
    for (let c of criteria) {
        if (useComparator(c, dependencyAttributeValue)) {
            oneMatches = true
            break
        }
    }

    // If none of them match, then the field fails
    if (!oneMatches) {
        return false
    }

    return true
}